import { Component } from "@angular/core";
import { LoginService } from "app/services/login/login.service";

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
  };

  @Component({
      selector: 'app-desembolso',
      templateUrl: './desembolso.component.html',
      styleUrls: ['./desembolso.component.scss']
  })

  export class DesembolsoComponent {

    constructor(private loginService:LoginService){}

    

    clickGuard(){
      this.loginService.clickGuard = true;
   }
}